import { useContext } from 'react';
import { IdentificationRequestsContext } from '@pages/IdentificationRequests/IdentificationRequests.query';
import { useQuery } from 'react-query';

import { IIdentificationRequest } from '@models/IdentificationRequests.model';
import { getIdentificationRequest } from '@services/queries/identificationRequests/getIdentificationRequest';
import { IdentificationRequestChatRaw } from './IdentificationRequestChat.raw';

interface IIdentificationRequestChatQuery {
  open: boolean;
  onClose: () => void;
}

export const IdentificationRequestChatQuery = (
  rawData: IIdentificationRequestChatQuery,
) => {
  const { selectedRequest } = useContext(IdentificationRequestsContext);

  const selectedRequestValue = selectedRequest.value;

  const { data } = useQuery(
    ['identificationRequests', 'assets', selectedRequestValue?.id],
    async () => {
      return getIdentificationRequest({
        id: selectedRequestValue?.id,
      });
    },
  );

  return (
    <IdentificationRequestChatRaw
      identificationRequest={data as IIdentificationRequest}
      {...rawData}
    />
  );
};
